<template>
    <div class="left-code">
        <div class="left-code-box">
            <img :src="codeLoad" alt="">
            <span>下载App,在线包车</span>
            <div class="developer">
                开发者：皇包车(厦门)科技集团
            </div>
            <div class="edition">
                版本号：1.0.4
            </div>
            <div class="jurisdiction">
                <div class="jurisdiction-text" @click="showYy(1)">隐私政策</div>
                <div class="jurisdiction-text" @click="showFw(0)">服务协议</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "leftCode",
        data() {
            return {
                codeLoad: require('@/assets/images/index/loadapppagecode.png')
            }
        },
        mounted() {
            // this.getHomeWebSet();
        },
        methods: {
            getHomeWebSet() {
                this.$axios.get('/HomeWebSet', {}).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        this.codeLoad = res.data.app_qr_code;
                    } else {
                        layer.msg('系统错误，请刷新', {icon: 2});
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },
            showYy(word){
                this.$router.push({name: 'HelpCenter',params: { type: word}});
            },
            showFw(word){
                this.$router.push({name: 'HelpCenter',params: { type: word}});
            }
        }
    }
</script>

<style scoped>
    .left-code {
        width: 200px;
        /*height: 210px;*/
        border: 1px solid #E5E5E5;
        border-radius: 2px;
        z-index: 20;
        position: fixed;
        top: 40%;
        left: 0;
        background: #fff;
    }

    .left-code-box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .left-code-box img {
        width: 136px;
        height: 136px;
        margin: 22px 0 0 0;
    }

    .left-code-box span {
        width: 160px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FA592A;
        text-align: center;
        margin-top: 10px;
    }

    .developer {
        width: 196px;
        text-align: left;
        margin-top: 10px;
    }

    .edition {
        width: 196px;
    }

    .jurisdiction {
        width: 160px;
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }

    .jurisdiction-text {
        width: 80px;
        text-align: center;
        color: #FA592A;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/leftCode.vue